import * as React from 'react';

import { translate } from '~l10n/client';
import { AlertMessage } from '~shared/components/AlertMessage';
import { IconButton, SmallButton } from '~shared/components/buttons';
import { IconX } from '~shared/components/icons/standard';
import { IconExclamationTriangle } from '~shared/components/icons/standard';

import { isMimeTypeError, isSizeError } from '../FileValidator/types';
import { FileDropFileWrapper } from './FileDropFileWrapper';

interface FileDropErrorProps {
  multiple?: boolean;
  fileName: string;
  handleRemove: () => void;
  handleRetry: () => void;
  error: unknown;
}
export function FileDropError({
  error,
  fileName,
  handleRemove,
  handleRetry,
  multiple = false,
}: FileDropErrorProps) {
  if (multiple) {
    return (
      <FileDropFileWrapper
        fileName={
          <FileDropFileWrapper.FileName>
            <IconExclamationTriangle />
            <FileDropFileWrapper.TruncatedFileName
              fileName={fileName}
              className="text-sm font-sans leading-8 text-red-800"
            />
          </FileDropFileWrapper.FileName>
        }
        actions={
          <FileDropFileWrapper.Actions>
            <SmallButton appearance="text" onClick={handleRetry}>
              {translate('Retry')}
            </SmallButton>
            <IconButton appearance="ghost" onClick={handleRemove}>
              <IconX title={translate('Remove')} titleId="file-drop-remove" />
            </IconButton>
          </FileDropFileWrapper.Actions>
        }
      />
    );
  }

  if (isMimeTypeError(error)) {
    return (
      <AlertMessage tone="critical" showIcon>
        {translate('Unsupported File Type')}
      </AlertMessage>
    );
  }

  if (isSizeError(error)) {
    return (
      <AlertMessage tone="critical" showIcon>
        {translate('File Size Too Large')}
      </AlertMessage>
    );
  }

  return (
    <AlertMessage tone="critical" showIcon>
      {translate('Unsupported File Type')}
    </AlertMessage>
  );
}
